import React from 'react';
import '../../assets/styles/components/preloader.scss';
import classNames from 'classnames';

const Preloader = props => {
    return (
        <div
            className={classNames({
                'preloader': true,
                'preloader--hidden': props.isHidden,
                'preloader--small': props.small,
                [props.class]: !!props.class
            })}
        >
            <div className="preloader-overlay">&nbsp;</div>
            <div className="preloader-wrapper">
                <div
                     className={classNames({
                         'preloader-spinner': true,
                     })}>
                    {!props.small && <div className="preloader-spinner-tail">
                    </div>}
                </div>
            </div>
        </div>
    );
};

export default Preloader;